import { getAllProducts } from './shipping-selectors';

export const getSelectedShippingOptions = state => {
    const result = getAllProducts(state)
        .filter(product => product.selected)
        .map(product => {
            const cost =
                product.cost || product.cost === 0
                    ? product.cost
                    : product.selectedVariant
                    ? product.selectedVariant.price
                    : product.cost;
            return {
                type: product.selectedVariant?.type || product.type,
                cost,
                name: product.name,
                summaryDisplayName: product.summaryDisplayName,
                weight: product.weight,
                productId: product.productId
            };
        });

    if (state.takeawayDeliveryAccepted) {
        const takeAwayOption =
            result.length === 0
                ? {
                      type: 'TakeawayOnly',
                      name: 'Endast avhämtning',
                      summaryDisplayName: 'Endast avhämtning'
                  }
                : {
                      type: 'Takeaway',
                      name: 'Avhämtning',
                      summaryDisplayName: 'Avhämtning'
                  };
        result.push(takeAwayOption);
    }
    return result;
};
